<template>
  <v-container>
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <static-page-content slug="cookie-policy" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'PageCookiePolicy'
}
</script>



// WEBPACK FOOTER //
// src/pages/cookie-policy.vue